import React from 'react';

export default function({children, light, orange, mintGreen}){
    
    return <h4 className={`mb-5 text-lg font-bold  ${mintGreen ? 'text-mint-green' : ``} ${light ? 'text-[#e1deb1]' : ``} ${orange ? 'text-orange' : ``} uppercase`}>{children}</h4>;

}